import React from "react";
import PropTypes from "prop-types";

const Link = ({ children, ...rest }) => {
  // if a target prop such as target="_blank" is passed in you need to add
  // rel="noopener" for security: https://developers.google.com/web/tools/lighthouse/audits/noopener
  const rel_prop = rest.target ?  {rel: "noopener"} : {};

  return (
    <a aria-label={rest["aria-label"] || rest.title} {...rel_prop} {...rest}>
      {children}
    </a>
  );
};

Link.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number, PropTypes.array]),
  title: PropTypes.string.isRequired,
};

Link.defaultProps = {
  children: () => null,
};

export default Link;
